/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonSharedAddressTypeDropdown200,
  GetApiV1PersonSharedAddressTypeDropdown401,
  GetApiV1PersonSharedAddressTypeDropdown500,
  GetApiV1PersonSharedAddressTypeDropdownQueryResponse,
} from "../../types/personSharedController/GetApiV1PersonSharedAddressTypeDropdown.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonSharedAddressTypeDropdown200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1PersonSharedAddressTypeDropdown200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonSharedAddressTypeDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedAddressTypeDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonSharedAddressTypeDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedAddressTypeDropdown500>;

export const getApiV1PersonSharedAddressTypeDropdownQueryResponseSchema =
  z.lazy(
    () => getApiV1PersonSharedAddressTypeDropdown200Schema,
  ) as unknown as ToZod<GetApiV1PersonSharedAddressTypeDropdownQueryResponse>;
